import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { BrowserStorageService } from '../../services/browser-storage.service';
import { EncryptionService } from '../../services/encryption.service';

@Injectable({
  providedIn: 'root'
})
export class NoAuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private browserStorage: BrowserStorageService,
    private encryption: EncryptionService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  canActivate(): boolean | UrlTree {
    if (!isPlatformBrowser(this.platformId)) {
      return true;
    }

    // Verificar directamente en sessionStorage (no usar valor cacheado)
    const accessToken = this.browserStorage.getSessionStorageItem('access');
    const encryptedUser = this.browserStorage.getSessionStorageItem('user');

    if (!accessToken || !encryptedUser) {
      return true; // No autenticado, permitir acceso a login/verify-code
    }

    try {
      const decrypted = this.encryption.decrypt(encryptedUser);
      const userObject = JSON.parse(decrypted);
      const user = Array.isArray(userObject) ? userObject[0] : userObject;

      if (user?.is_authenticator_activated && user?.is_active) {
        // Usuario completamente autenticado: bloquear acceso a rutas pre-auth
        this.router.navigate(['/dashboard']);
        return false;
      }
    } catch {
      // Si falla el descifrado, permitir acceso
    }

    return true;
  }
}
